<div class="payment-page">
  <header class="payment-header">
    <button mat-button class="back-btn" (click)="goBack()"><mat-icon>arrow_back</mat-icon></button>
    <a class="brand" href="/">
      <img *ngIf="tenantLogo" class="brand-logo" [src]="tenantLogo" alt="">
      <ng-container *ngIf="!tenantLogo"><mat-icon>bolt</mat-icon><span>{{ tenantName || ('qrcode.brand' | translate) }}</span></ng-container>
    </a>
    <div class="header-right">
      <button mat-button class="header-help" (click)="redirectToEv24()">{{'qrcode.help' | translate}}</button>
      <div class="header-context"><mat-icon>credit_card</mat-icon><span>{{'payment.payment' | translate}}</span></div>
      <div class="lang-selector">
        <button class="lang-btn" [class.active]="selectedLanguage === 'fr'" (click)="changeLanguage('fr')">FR</button>
        <button class="lang-btn" [class.active]="selectedLanguage === 'en'" (click)="changeLanguage('en')">EN</button>
      </div>
    </div>
  </header>

  <main class="payment-main">
    <section class="payment-layout">
      <article class="payment-card">
        <div class="card-title"><mat-icon>credit_card</mat-icon><h2>{{'payment.payment' | translate}}</h2></div>
        <p class="cryptee">{{'payment.cryptee' | translate}}</p>

        <mat-radio-group class="payment-method" aria-label="Select an option" [(ngModel)]="selectedValue">
          <mat-radio-button value="1">
            <span class="span">{{'payment.credit_card' | translate}}</span>
          </mat-radio-button>
        </mat-radio-group>

        <form class="form" [formGroup]="cardForm">
          <div class="form-group">
            <label>{{'settings.billing.payment_methods_card' | translate}}</label>
            <div class="stripe-field" id="cardNumber"></div>
            <div class="field-error" *ngIf="cardNumberError">{{cardNumberError}}</div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label>{{'settings.billing.payment_methods_expiring_on' | translate}}</label>
              <div class="stripe-field" id="cardExp"></div>
              <div class="field-error" *ngIf="expirationDateError">{{expirationDateError}}</div>
            </div>
            <div class="form-group">
              <label>{{'settings.billing.payment_methods_verification_code' | translate}}</label>
              <div class="stripe-field" id="cardCvc"></div>
              <div class="field-error" *ngIf="cvcError">{{cvcError}}</div>
            </div>
          </div>

          <div class="form-group">
            <mat-checkbox formControlName="acceptConditions">
              <span class="conditions">{{'settings.billing.payment_methods_check' | translate}}</span>
            </mat-checkbox>
            <div class="field-error" *ngIf="cardForm.controls['acceptConditions'].invalid && cardForm.controls['acceptConditions'].touched">
              {{'payment.conditions' | translate}}
            </div>
          </div>

          <button mat-flat-button class="primary-action full-width" type="submit" (click)="onSubmit()">
            {{'payment.Submit' | translate}}
          </button>
        </form>
      </article>
    </section>
  </main>
</div>
